import { defineBreakpoints } from '@/core/responsive/breakpoints/breakpoints.service';
import { createBreakpointList } from '@/core/responsive/breakpoints/create-breakpoints-list';

const breakpoints = require('../../styling/0-Settings/breakpoints.js');

const screens = {
    xs: breakpoints.xs,
    sm: breakpoints.sm,
    md: breakpoints.md,
    lg: breakpoints.lg,
    xl: breakpoints.xl,
    xxl: breakpoints.xxl,
};

/*
// Lets use tailwind config as breakpoint-src
// PREMISE: tailwind config has 'px' units

  Converts something like this:
    screens: {
        small: '0',
        medium: '600px',
        desk: '960px',
        large: '1025px',
    },

   To something like this:
   {
       small: { min: 0, max: 599 },
       medium: { min: 600, max: 959 },
       desk: { min: 960, max: 1023 },
       large: { min: 1024, max: 999999 },
   }
*/

const finalBreakpoints = createBreakpointList(screens);

defineBreakpoints(finalBreakpoints);
